import { Compass } from 'lucide-react';
import { Link } from 'react-router';
import { Card } from '@/components/ui/Card';
import { EmptyState } from '@/components/ui/EmptyState';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas p-4">
      <Card className="w-full max-w-lg">
        <EmptyState
          icon={Compass}
          title="Page not found"
          description={
            <Link to="/" className="text-brand underline">
              Go to the home page
            </Link>
          }
        />
      </Card>
    </div>
  );
}
